var exports = {
  "kL": "x127c5a35--ff043c--container",
  "qO": "x127c5a35--ff043c--container--error",
  "iE": "x127c5a35--ff043c--wrapper",
  "h": "x127c5a35--ff043c--close-wrapper",
  "VN": "x127c5a35--ff043c--close",
  "Ae": "x127c5a35--ff043c--animation-enter",
  "hl": "x127c5a35--ff043c--animation-enter-active",
  "jM": "x127c5a35--ff043c--animation-leave",
  "sv": "x127c5a35--ff043c--animation-leave-active",
};

module.exports = exports;
